import {DETAIL_NEW_CYCLE_START} from "../../types";

export const detail_new_cycle = (payload) => ({
    type: DETAIL_NEW_CYCLE_START,
    payload,
});
